/* Leathulce theme JS — cart drawer, age gate, wishlist, header, product form.
   Mirrors the prototype's behaviour on top of Shopify's AJAX cart + predictive search. */
(function () {
  'use strict';
  var L = window.Leathulce || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg) {
    var el = $('#lc-toast'); if (!el) return;
    el.textContent = msg; el.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function () { el.hidden = true; }, 2200);
  }
  L.toast = toast;

  /* ---------- age gate (remembered for 30 days) ---------- */
  (function gate() {
    var g = $('[data-age-gate]'); if (!g) return;
    var KEY = 'lc-age-ok';
    if (g.hasAttribute('data-design-mode')) {
      /* Theme editor: keep the page visible; show the gate only while its section is selected. */
      document.addEventListener('shopify:section:select', function (e) { if (e.target && e.target.contains(g)) g.style.display = ''; });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target && e.target.contains(g)) g.style.display = 'none'; });
      return;
    }
    try { if (localStorage.getItem(KEY)) { g.remove(); return; } } catch (e) {}
    document.documentElement.style.overflow = 'hidden';
    $('[data-gate-enter]', g).addEventListener('click', function () {
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
      g.remove(); document.documentElement.style.overflow = '';
    });
    $('[data-gate-exit]', g).addEventListener('click', function () {
      $('[data-gate-denied]', g).hidden = false;
      setTimeout(function () { location.href = g.getAttribute('data-exit-url') || 'https://www.google.com'; }, 1400);
    });
  })();

  /* ---------- wishlist (localStorage) ---------- */
  var wish = (function () {
    var KEY = 'lc-wish';
    function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
    function paint() {
      var list = read();
      $$('[data-wish]').forEach(function (b) {
        var on = list.indexOf(b.getAttribute('data-wish')) >= 0;
        b.classList.toggle('is-on', on); b.textContent = on ? '♥' : '♡';
      });
      $$('[data-wish-count]').forEach(function (c) { c.textContent = list.length; c.hidden = !list.length; });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wish]'); if (!b) return;
      e.preventDefault();
      var h = b.getAttribute('data-wish'), list = read(), i = list.indexOf(h);
      if (i >= 0) { list.splice(i, 1); toast('Removed from wishlist'); } else { list.push(h); toast('Saved to wishlist'); }
      write(list); paint();
    });
    paint();
    return { read: read };
  })();

  /* ---------- cart drawer ---------- */
  var cart = (function () {
    var drawer = $('[data-cart-drawer]');
    var state = null;
    function money(c) { return L.money ? L.money(c) : '$' + (c / 100).toFixed(2); }
    function open() { if (!drawer) return; drawer.hidden = false; document.documentElement.style.overflow = 'hidden'; }
    function close() { if (!drawer) return; drawer.hidden = true; document.documentElement.style.overflow = ''; }
    function fetchCart() { return fetch(L.routes.cartJson, { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
    function render(c) {
      state = c;
      $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
      if (!drawer) return;
      var sub = c.items_subtotal_price, remaining = Math.max(0, L.freeShipOver - sub), pct = Math.min(100, L.freeShipOver ? sub / L.freeShipOver * 100 : 100);
      $('[data-ship-text]', drawer).textContent = remaining > 0 ? 'Add ' + money(remaining) + ' more for free shipping' : 'Free shipping unlocked';
      $('[data-ship-bar]', drawer).style.width = pct + '%';
      var gap = Math.max(0, L.couponAt - sub), ct = $('[data-coupon-text]', drawer);
      if (ct) { ct.hidden = !c.item_count; ct.textContent = gap > 0 ? 'Add ' + money(gap) + ' more to take ' + money(L.couponAmt) + ' off' : money(L.couponAmt) + ' off — use code ' + L.couponCode + ' at checkout'; }
      var addons = $('[data-add-ons]', drawer); if (addons) addons.hidden = !(c.item_count && gap > 0);
      $('[data-cart-title-count]', drawer).textContent = '(' + c.item_count + ')';
      $('[data-cart-empty]', drawer).hidden = !!c.item_count;
      $('[data-subtotal]', drawer).textContent = money(sub);
      var list = $('[data-cart-items]', drawer);
      list.innerHTML = c.items.map(function (it, i) {
        var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_168x168$1$2') + '" alt="">' : '';
        return '<div class="lc-cart-item"><a class="lc-cart-item__img" href="' + it.url + '">' + img + '</a>' +
          '<div class="lc-cart-item__body"><div class="lc-cart-item__row"><a class="lc-cart-item__name" href="' + it.url + '">' + it.product_title + '</a><div class="lc-cart-item__line">' + money(it.final_line_price) + '</div></div>' +
          '<div class="lc-cart-item__variant">' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '') + '</div>' +
          '<div class="lc-cart-item__row lc-cart-item__ctl"><div class="lc-qty lc-qty--sm"><button type="button" data-cart-dec="' + (i + 1) + '" data-q="' + it.quantity + '">−</button><span>' + it.quantity + '</span><button type="button" data-cart-inc="' + (i + 1) + '" data-q="' + it.quantity + '">+</button></div>' +
          '<button type="button" class="lc-cart-item__remove" data-cart-remove="' + (i + 1) + '">Remove</button></div></div></div>';
      }).join('');
    }
    function refresh() { return fetchCart().then(render); }
    function change(line, qty) {
      return fetch(L.routes.cartChange, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(render);
    }
    function add(variantId, qty) {
      return fetch(L.routes.cartAdd + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: qty || 1 }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { return refresh(); }).then(function () { open(); })
        .catch(function (r) { (r.json ? r.json() : Promise.resolve({})).then(function (j) { toast(j.description || j.message || 'Could not add that item'); }); });
    }
    document.addEventListener('click', function (e) {
      var t = e.target;
      var a = t.closest('[data-add-to-cart]'); if (a) { e.preventDefault(); add(a.getAttribute('data-add-to-cart'), 1); return; }
      if (t.closest('[data-cart-open]')) { e.preventDefault(); refresh().then(open); return; }
      if (t.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }
      var inc = t.closest('[data-cart-inc]'); if (inc) { change(+inc.getAttribute('data-cart-inc'), +inc.getAttribute('data-q') + 1); return; }
      var dec = t.closest('[data-cart-dec]'); if (dec) { change(+dec.getAttribute('data-cart-dec'), Math.max(0, +dec.getAttribute('data-q') - 1)); return; }
      var rm = t.closest('[data-cart-remove]'); if (rm) { change(+rm.getAttribute('data-cart-remove'), 0); return; }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    refresh();
    return { add: add, open: open, close: close, refresh: refresh };
  })();
  L.cart = cart;

  /* ---------- all sales final: the bag's checkbox must be ticked before checkout ---------- */
  (function finalSale() {
    var KEY = 'Final sale accepted';
    function boxes() { return $$('[data-final-sale-check]'); }
    function guardOf(el) { var f = el.closest('form, .lc-drawer__foot'); return f ? $('[data-final-sale]', f) : null; }
    function blockedBy(el) { var w = guardOf(el); var cb = w && $('[data-final-sale-check]', w); return cb && !cb.checked ? w : null; }
    function paint() {
      $$('[data-checkout]').forEach(function (btn) {
        var blocked = !!blockedBy(btn);
        btn.classList.toggle('is-disabled', blocked);
        btn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      });
    }
    function nudge(w) {
      w.classList.add('is-attention');
      var cb = $('[data-final-sale-check]', w); if (cb) cb.focus();
      toast('Please tick the box to confirm all sales are final.');
    }
    document.addEventListener('change', function (e) {
      var cb = e.target.closest && e.target.closest('[data-final-sale-check]'); if (!cb) return;
      boxes().forEach(function (b) { b.checked = cb.checked; });
      if (cb.checked) $$('[data-final-sale]').forEach(function (w) { w.classList.remove('is-attention'); });
      paint();
      var attrs = {}; attrs[KEY] = cb.checked ? 'Yes' : '';
      fetch(L.routes.cart + '/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-checkout]'); if (!btn) return;
      var w = blockedBy(btn); if (!w) return;
      e.preventDefault(); e.stopPropagation(); nudge(w);
    }, true);
    document.addEventListener('submit', function (e) {
      var w = e.target.querySelector && $('[data-final-sale]', e.target); if (!w) return;
      var cb = $('[data-final-sale-check]', w);
      if (cb && !cb.checked) { e.preventDefault(); nudge(w); }
    }, true);
    paint();
  })();

  /* ---------- product form (qty, variant, add) ---------- */
  (function productForm() {
    var f = $('[data-product-form]'); if (!f) return;
    var variants = JSON.parse($('[data-variants-json]', f).textContent);
    var qtyEl = $('[data-qty]', f), price = $('[data-line-total]', f), addBtn = $('[data-product-add]', f);
    var sel = { qty: 1 };
    function current() {
      var opts = $$('[data-option-group]', f).map(function (g) { return g.getAttribute('data-selected'); });
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }) || variants[0];
    }
    function paint() {
      var v = current();
      qtyEl.textContent = sel.qty;
      if (price) price.textContent = 'Add to bag — ' + (L.money ? L.money(v.price * sel.qty) : '');
      addBtn.disabled = !v.available;
      if (!v.available) price.textContent = 'Sold out';
      $$('[data-option-group]', f).forEach(function (g) {
        $$('button', g).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-value') === g.getAttribute('data-selected')); });
        var lab = $('[data-option-current]', g.parentNode); if (lab) lab.textContent = g.getAttribute('data-selected');
      });
    }
    f.addEventListener('click', function (e) {
      var o = e.target.closest('[data-value]'); if (o) { o.closest('[data-option-group]').setAttribute('data-selected', o.getAttribute('data-value')); paint(); return; }
      if (e.target.closest('[data-qty-inc]')) { sel.qty++; paint(); return; }
      if (e.target.closest('[data-qty-dec]')) { sel.qty = Math.max(1, sel.qty - 1); paint(); return; }
      if (e.target.closest('[data-product-add]')) { e.preventDefault(); cart.add(current().id, sel.qty); return; }
    });
    $$('[data-accordion] button', f.closest('main') || document).forEach(function (b) {
      b.addEventListener('click', function () {
        var item = b.parentNode, open = item.classList.toggle('is-open');
        $('[data-accordion-icon]', b).textContent = open ? '−' : '+';
      });
    });
    paint();
  })();

  /* ---------- header: mega menu, mobile menu, search suggestions ---------- */
  (function header() {
    var h = $('[data-header]'); if (!h) return;
    var menus = $$('[data-menu-panel]', h), timer;
    function show(key) { menus.forEach(function (m) { m.hidden = m.getAttribute('data-menu-panel') !== key; }); $$('[data-nav-key]', h).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-nav-key') === key); }); }
    $$('[data-nav-key]', h).forEach(function (b) { b.addEventListener('mouseenter', function () { clearTimeout(timer); show(b.getAttribute('data-menu-panel') ? b.getAttribute('data-nav-key') : null); }); });
    $('[data-nav]', h) && $('[data-nav]', h).addEventListener('mouseleave', function () { timer = setTimeout(function () { show(null); }, 150); });
    var mm = $('[data-mobile-menu]');
    $$('[data-mobile-toggle]').forEach(function (b) { b.addEventListener('click', function () { mm.hidden = !mm.hidden; document.documentElement.style.overflow = mm.hidden ? '' : 'hidden'; }); });
    // predictive search suggestions (Shopify Predictive Search API)
    $$('[data-search-input]').forEach(function (inp) {
      var box = inp.parentNode.querySelector('[data-search-sugs]'); if (!box) return;
      var t;
      inp.addEventListener('input', function () {
        clearTimeout(t); var q = inp.value.trim();
        if (q.length < 2) { box.hidden = true; return; }
        t = setTimeout(function () {
          fetch(L.routes.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=5', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); }).then(function (j) {
              var res = j.resources.results, items = [];
              (res.collections || []).slice(0, 2).forEach(function (c) { items.push('<a class="lc-sug" href="' + c.url + '"><span>' + c.title + '</span><span class="lc-sug__kind">Category</span></a>'); });
              (res.products || []).forEach(function (p) { items.push('<a class="lc-sug" href="' + p.url + '"><span>' + p.title + '</span><span class="lc-sug__kind">' + (L.money ? L.money(p.price * 100) : '') + '</span></a>'); });
              box.innerHTML = items.join('') + '<a class="lc-sug lc-sug--all" href="' + L.routes.search + '?q=' + encodeURIComponent(q) + '">See all results for “' + q.replace(/</g, '&lt;') + '”</a>';
              box.hidden = false;
            }).catch(function () { box.hidden = true; });
        }, 180);
      });
      inp.addEventListener('blur', function () { setTimeout(function () { box.hidden = true; }, 150); });
      inp.addEventListener('keydown', function (e) { if (e.key === 'Escape') box.hidden = true; });
    });
  })();

  /* ---------- collection: sort select + mobile filter toggle ---------- */
  (function collection() {
    var s = $('[data-sort-select]'); if (s) s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u.toString(); });
    var ft = $('[data-filters-toggle]'), fp = $('[data-filters]'); if (ft && fp) ft.addEventListener('click', function () { fp.classList.toggle('is-open'); });
  })();

  window.Leathulce = L;
})();


/* ==========================================================================
Product gallery: thumbnails switch the main image, main image opens a
lightbox (prev / next / close, arrow keys, Esc, click outside), and picking
a variant (colour, style...) shows that variant's own photo.
Added 2026-09-19. Markup it expects (product section):
.lc-pdp__gallery > .lc-pdp__main > img
.lc-pdp__gallery > .lc-pdp__thumbs > button.lc-pdp__thumb[data-thumb="<image url>"] > img
========================================================================== */
(function () {
'use strict';

var CSS = ''
+ '.lc-pdp__main{cursor:zoom-in}'
+ '.lc-pdp__main img{transition:opacity .18s ease}'
+ '.lc-pdp__main.is-swapping img{opacity:.35}'
+ '.lc-pdp__thumb{cursor:pointer}'
+ '.lc-pdp__thumb.is-on{outline:2px solid currentColor;outline-offset:2px}'
+ '@media (max-width:640px){.lc-pdp__thumbs{display:flex;overflow-x:auto;gap:10px;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding-bottom:6px;scrollbar-width:thin}.lc-pdp__thumb{flex:0 0 22%;scroll-snap-align:start}}'
+ '.lc-lightbox{position:fixed;inset:0;z-index:9999;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.92);padding:16px}'
+ '.lc-lightbox.is-open{display:flex}'
+ '.lc-lightbox img{max-width:min(96vw,1400px);max-height:90vh;object-fit:contain;border-radius:8px;box-shadow:0 20px 60px rgba(0,0,0,.6)}'
+ '.lc-lightbox__btn{position:absolute;top:50%;transform:translateY(-50%);width:48px;height:48px;border:0;border-radius:50%;background:rgba(255,255,255,.12);color:#fff;font-size:26px;line-height:48px;text-align:center;cursor:pointer}'
+ '.lc-lightbox__btn:hover{background:rgba(255,255,255,.24)}'
+ '.lc-lightbox__btn--prev{left:16px}.lc-lightbox__btn--next{right:16px}'
+ '.lc-lightbox__close{position:absolute;top:14px;right:16px;width:44px;height:44px;border:0;border-radius:50%;background:rgba(255,255,255,.12);color:#fff;font-size:24px;line-height:44px;cursor:pointer}'
+ '.lc-lightbox__count{position:absolute;bottom:16px;left:50%;transform:translateX(-50%);color:#ddd;font-size:13px;letter-spacing:.5px}'
+ '.lc-lightbox--single .lc-lightbox__btn{display:none}'
+ 'body.lc-lightbox-open{overflow:hidden}';

function injectCSS() {
if (document.getElementById('lc-gallery-css')) return;
var s = document.createElement('style');
s.id = 'lc-gallery-css';
s.textContent = CSS;
document.head.appendChild(s);
}

function buildLightbox() {
var lb = document.getElementById('lc-lightbox');
if (lb) return lb;
lb = document.createElement('div');
lb.id = 'lc-lightbox';
lb.className = 'lc-lightbox';
lb.setAttribute('role', 'dialog');
lb.setAttribute('aria-modal', 'true');
lb.setAttribute('aria-label', 'Product photo');
lb.innerHTML =
'<button type="button" class="lc-lightbox__close" aria-label="Close">&times;</button>' +
'<button type="button" class="lc-lightbox__btn lc-lightbox__btn--prev" aria-label="Previous photo">&#8249;</button>' +
'<img alt="">' +
'<button type="button" class="lc-lightbox__btn lc-lightbox__btn--next" aria-label="Next photo">&#8250;</button>' +
'<div class="lc-lightbox__count"></div>';
document.body.appendChild(lb);
return lb;
}

function initGallery(gallery) {
if (!gallery || gallery.getAttribute('data-lc-gallery') === 'ready') return;
var mainWrap = gallery.querySelector('.lc-pdp__main');
var mainImg = mainWrap && mainWrap.querySelector('img');
var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.lc-pdp__thumb'));
if (!mainImg) return;
gallery.setAttribute('data-lc-gallery', 'ready');

var urls = thumbs.map(function (b) { return b.getAttribute('data-thumb') || (b.querySelector('img') || {}).src || ''; })
.filter(Boolean);
if (!urls.length) urls = [mainImg.currentSrc || mainImg.src];
var alts = thumbs.map(function (b) { return b.getAttribute('aria-label') || mainImg.alt || ''; });
var index = Math.max(0, thumbs.findIndex(function (b) { return b.classList.contains('is-on'); }));

/* same photo, different size/URL params -> same key */
function norm(u) {
u = String(u || '').split('?')[0];
u = u.substring(u.lastIndexOf('/') + 1);
return u.replace(/_(\d+x\d*|\d*x\d+)(_crop_[a-z]+)?(?=\.[a-z0-9]+$)/i, '').toLowerCase();
}

function show(i) {
if (!urls.length) return;
i = (i + urls.length) % urls.length;
index = i;
mainWrap.classList.add('is-swapping');
var next = new Image();
next.onload = next.onerror = function () {
mainImg.removeAttribute('srcset');
mainImg.removeAttribute('sizes');
mainImg.src = urls[i];
if (alts[i]) mainImg.alt = alts[i];
mainWrap.classList.remove('is-swapping');
};
next.src = urls[i];
thumbs.forEach(function (b, k) {
b.classList.toggle('is-on', k === i);
b.setAttribute('aria-current', k === i ? 'true' : 'false');
});
var on = thumbs[i], strip = on && on.parentElement; if (strip && strip.scrollWidth > strip.clientWidth + 2) { strip.scrollLeft += (on.getBoundingClientRect().left - strip.getBoundingClientRect().left) - (strip.clientWidth - on.offsetWidth) / 2; }
}
/* show a photo that may not be in the thumbnail strip (a variant's image) */
function showUrl(src, alt) {
var key = norm(src);
var k = -1;
for (var n = 0; n < urls.length; n++) { if (norm(urls[n]) === key) { k = n; break; } }
if (k < 0) { urls.push(src); alts.push(alt || ''); k = urls.length - 1; }
show(k);
}

thumbs.forEach(function (b, k) {
b.addEventListener('click', function (e) { e.preventDefault(); show(k); });
b.addEventListener('keydown', function (e) {
if (e.key === 'ArrowRight') { e.preventDefault(); show(k + 1); (thumbs[(k + 1) % thumbs.length] || b).focus(); }
if (e.key === 'ArrowLeft') { e.preventDefault(); show(k - 1); (thumbs[(k - 1 + thumbs.length) % thumbs.length] || b).focus(); }
});
});

/* variant -> photo: the theme sets data-selected on each option group when a pill is picked */
var form = gallery.closest('[data-product-form]') || document.querySelector('[data-product-form]');
var variants = null;
if (form) {
try {
var sc = form.querySelector('script[type="application/json"]');
var parsed = sc && JSON.parse(sc.textContent);
if (Array.isArray(parsed) && parsed.length && parsed[0] && ('option1' in parsed[0])) variants = parsed;
} catch (e) { variants = null; }
}
if (form && variants) {
var lastKey = null;
var syncVariant = function () {
var groups = Array.prototype.slice.call(form.querySelectorAll('[data-option-group]'));
var vals = groups.map(function (g) { return g.getAttribute('data-selected'); });
var v = null;
for (var n = 0; n < variants.length; n++) {
var c = variants[n], ok = true;
for (var q = 0; q < vals.length; q++) { if (vals[q] && c['option' + (q + 1)] !== vals[q]) { ok = false; break; } }
if (ok) { v = c; break; }
}
if (!v || !v.featured_image || !v.featured_image.src) return;
var key = norm(v.featured_image.src);
if (key === lastKey) return;
lastKey = key;
showUrl(v.featured_image.src, v.name || '');
};
if (window.MutationObserver) {
new MutationObserver(function () { syncVariant(); })
.observe(form, { attributes: true, subtree: true, attributeFilter: ['data-selected'] });
}
form.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-option-group] [data-value]')) setTimeout(syncVariant, 0); });
if (/[?&]variant=/.test(location.search)) syncVariant();
}

/* lightbox */
var lb = buildLightbox();
var lbImg = lb.querySelector('img');
var lbCount = lb.querySelector('.lc-lightbox__count');
var lbIndex = 0;
var lastFocus = null;

function lbShow(i) {
i = (i + urls.length) % urls.length;
lbIndex = i;
lbImg.src = urls[i];
lbImg.alt = alts[i] || '';
lbCount.textContent = urls.length > 1 ? (i + 1) + ' / ' + urls.length : '';
lb.classList.toggle('lc-lightbox--single', urls.length < 2);
}
function lbOpen(i) {
lastFocus = document.activeElement;
lbShow(i);
lb.classList.add('is-open');
document.body.classList.add('lc-lightbox-open');
lb.querySelector('.lc-lightbox__close').focus();
}
function lbClose() {
lb.classList.remove('is-open');
document.body.classList.remove('lc-lightbox-open');
show(lbIndex);
if (lastFocus && lastFocus.focus) lastFocus.focus();
}

mainWrap.addEventListener('click', function () { lbOpen(index); });
mainWrap.setAttribute('role', 'button');
mainWrap.setAttribute('tabindex', '0');
mainWrap.setAttribute('aria-label', 'Open photo full size');
mainWrap.addEventListener('keydown', function (e) {
if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); lbOpen(index); }
});

if (!lb.getAttribute('data-wired')) {
lb.setAttribute('data-wired', '1');
lb.querySelector('.lc-lightbox__close').addEventListener('click', function () { lb._close && lb._close(); });
lb.querySelector('.lc-lightbox__btn--prev').addEventListener('click', function () { lb._step && lb._step(-1); });
lb.querySelector('.lc-lightbox__btn--next').addEventListener('click', function () { lb._step && lb._step(1); });
lb.addEventListener('click', function (e) { if (e.target === lb) lb._close && lb._close(); });
document.addEventListener('keydown', function (e) {
if (!lb.classList.contains('is-open')) return;
if (e.key === 'Escape') { e.preventDefault(); lb._close && lb._close(); }
if (e.key === 'ArrowRight') { e.preventDefault(); lb._step && lb._step(1); }
if (e.key === 'ArrowLeft') { e.preventDefault(); lb._step && lb._step(-1); }
});
var touchX = null;
lb.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
lb.addEventListener('touchend', function (e) {
if (touchX === null) return;
var dx = e.changedTouches[0].clientX - touchX; touchX = null;
if (Math.abs(dx) > 40 && lb._step) lb._step(dx < 0 ? 1 : -1);
}, { passive: true });
}
lb._close = lbClose;
lb._step = function (d) { lbShow(lbIndex + d); };
}

function boot() {
injectCSS();
Array.prototype.forEach.call(document.querySelectorAll('.lc-pdp__gallery'), initGallery);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
document.addEventListener('shopify:section:load', boot);
})();
